import type { Bible, ChangeOperation } from "./types";

function collect(bible: Bible): Map<string, { type: string; value: unknown }> {
  const map = new Map<string, { type: string; value: unknown }>();
  const add = (type: string, id: string, value: unknown) => map.set(`${type}:${id}`, { type, value });
  for (const x of bible.books) add("book", x.id, x);
  for (const x of bible.branches) add("branch", x.id, x);
  for (const x of bible.moments) add("moment", x.id, x);
  for (const x of bible.characters) add("character", x.id, x);
  for (const x of bible.events) add("event", x.id, x);
  for (const x of bible.relationships) add("relationship", x.id, x);
  for (const x of bible.secrets) add("secret", x.id, x);
  for (const x of bible.continuityIssues) add("issue", x.id, x);
  return map;
}

function stable(value: unknown): string {
  return JSON.stringify(value);
}

export function diffBibles(before: Bible, after: Bible): ChangeOperation[] {
  const a = collect(before);
  const b = collect(after);
  const ops: ChangeOperation[] = [];
  for (const [key, left] of a) {
    const right = b.get(key);
    if (!right) {
      ops.push({
        operation: "delete",
        entityType: left.type,
        entityId: key.slice(key.indexOf(":") + 1),
        before: left.value,
      });
    } else if (stable(left.value) !== stable(right.value)) {
      ops.push({
        operation: "update",
        entityType: left.type,
        entityId: key.slice(key.indexOf(":") + 1),
        before: left.value,
        after: right.value,
      });
    }
  }
  for (const [key, right] of b) {
    if (!a.has(key)) {
      ops.push({
        operation: "create",
        entityType: right.type,
        entityId: key.slice(key.indexOf(":") + 1),
        after: right.value,
      });
    }
  }
  return ops;
}

export function summarizeDiff(ops: ChangeOperation[]): string {
  const n = (op: ChangeOperation["operation"]) => ops.filter((x) => x.operation === op).length;
  return `${n("create")} ajout(s), ${n("update")} modification(s), ${n("delete")} suppression(s)`;
}
